<template>
  <div style="margin-top: 20px; margin-left: -20px;">
    <el-form :inline="true" size="mini" :model="search" class="demo-form-inline" style="margin: 0">
      <el-form-item label="出发日期">
        <el-date-picker v-model="search.ChuFaRiQi_S" type="date" placeholder="出发日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="至">
        <el-date-picker v-model="search.ChuFaRiQi_E" type="date" placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="关键字">
        <el-input v-model="search.Keyword" placeholder="出发地、到达地"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reload">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-radio-group @change="reload" v-model="search.YunShuStatus">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="0">未起运</el-radio-button>
          <el-radio-button label="1">运送中</el-radio-button>
          <el-radio-button label="2">已到达</el-radio-button>
          <el-radio-button label="3">已完成</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <table v-loading="showLoading" class="JY-order-one JY-order-oneB" width="100%;">
      <thead>
        <tr>
          <th style="width:30%">货物始发地及目的地</th>
          <th class="taC" style="width:15%">日期</th>
          <th class="taC" style="width:15%"></th>
          <th class="taC" style="width:20%"></th>
          <th class="taC" style="width:12%">状态</th>
          <th class="taC">操作</th>
        </tr>
      </thead>
    </table>
    <div v-for="item in items" :key="item.ID" class="JY-order-one JY-order-one-transport">
      <table width="100%;">
        <thead>
          <tr>
            <th colspan="6">
              <span style="font-weight: 600;">{{item.CreateTime}}</span>
              <span style="margin-left:10px;">订单号：{{item.OrderNo}}</span>
              <span style="margin-left:10px;">运单号：{{item.OrderYunDanNo}}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="width:30%">
              <p><strong>出发地</strong><span class="jobs">{{item.ChuFaDi}}</span><br><strong>到达地</strong><span class="jobs">{{item.DaoDaDi}}</span></p>
            </td>
            <td class="taL" style="width:15%">
              <p>
                <span>出发日期:{{item.QiYunRiQi}}</span><br>
                <span>到达日期:{{item.DaoDaRiQi}}</span>
              </p>
            </td>
            <td class="taC" style="width:15%">
              <p>
                <span>单价:{{formatNumber(item.YunFeiDanJia)}}元</span><br>
                <span>总价:{{formatNumber(item.YunFeiTotal)}}元</span><br>
                <span>重量:{{item.FaHuoZhongLiang}}吨</span>
              </p>
            </td>
            <td class="taL" style="width:20%">
              <p>
                <span>车型:{{item.CarModelID||'-'}}</span><br>
                <span>车牌:{{item.ChePaiHao}}</span><br>
                <span>驾驶人:{{item.ShiJiDriverUserName}}</span>
              </p>
            </td>
            <td class="taC" style="width:12%">
              <p>{{item.YunShuStatus}}</p>
            </td>
            <td class="taC" style="border-right: 0;">
              <p><a href="javascript:;" @click="openOrder(item)">查看详情</a></p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row mt10" style="margin-left: 0; margin-top: 10px;">
      <el-pagination @current-change="loadMore" background :page-size="search.PageSize" layout="total, prev, pager, next" :total="total">
      </el-pagination>
    </div>
    <el-dialog title="订单详情" width="80%" top="1vh" :visible.sync="dialogVisible">
      <good-detail :good="selectedGood" :images="selectedGoodImages"></good-detail>
    </el-dialog>
  </div>
</template>

<script>
  import api from "../api";
  import util from "../libs/util";
  import goodDetail from "./goodDetail";

  export default {
    components: {
      goodDetail
    },
    data() {
      return {
        selectedGood: {},
        selectedGoodImages: [],
        dialogVisible: false,
        showLoading: false,
        items: [],
        total: 0,
        search: {
          PageNo: 1,
          PageSize: 20,
          YunShuStatus: "",
          ChuFaRiQi_S: "",
          ChuFaRiQi_E: "",
          Keywords: "",
          OrderNo: "",
          OrderYunDanNo: ""
        }
      };
    },
    methods: {
      formatNumber(n){
        return util.getThousandNumber(n);
      },
      openOrder(order) {
        let _this = this;
        _this.showLoading = true;
        api.getSourceGood({id: order.SourceGoodsID}).then(res => {
          _this.showLoading = false;
          if (!res.data.Succeed) {
            _this.$message({
              message: res.data.Message,
              type: "error"
            });
            return
          }
          _this.dialogVisible = true;
          _this.selectedGood = res.data.Data.Data;
          if (res.data.Data.BaoJia) {
            _this.baoJia = res.data.Data.BaoJia;
            _this.baoJiaTotal = res.data.Data.BaoJia.Total;
            _this.baoJiaJson = JSON.parse(_this.baoJia.BaoJiaJson);
          } else {
            if (_this.selectedGood.BaoJiaLeiXing == '1') {
              _this.baoJiaJson = _this.selectedGood.CarList
            }
          }
          _this.selectedGoodImages = [];
          if (res.data.Data.Attachments) {
            res.data.Data.Attachments.forEach(item => {
              _this.selectedGoodImages.push(
                process.env.BASE_API+'/Apps/JYJYManage/Preview/PreviewImage?id='+item.AttID
              );
            });
          }
        });
      },
      loadMore(n) {
        this.search.PageNo = n;
        this.loadItems();
      },
      reload() {
        this.search.PageNo = 1;
        this.loadItems();
      },
      loadItems() {
        let _this = this;
        _this.showLoading = true;
        api.getYunDans(_this.search).then(res => {
          _this.showLoading = false;
          if (res.data.Succeed) {
            _this.items = res.data.Data.Data;
            _this.total = res.data.Data.totalItemCount;
          }
        });
      }
    },
    mounted() {
      this.loadItems();
    }
  };
</script>

<style>
  .JY-items-list,
  .JY-items-search {
    width: 100%;
  }
  span.el-tag {
    margin-right: 5px;
  }
  .el-table th.gutter {
    display: table-cell !important;
  }
</style>




// WEBPACK FOOTER //
// src/components/orderTable.vue